const i18n = {
    day: {
        1 : "{0} день", 
        0 : "{0} дзень"
    },
	days: {
		1 : "{0} дней",
		0 : "{0} дзён"
	},
	noActiveWorkDays: {
		1 : "Выбор срока исполнения обращения недоступен! Пожалуйста, заполните график работы организации в личном кабинете Внешнего Администратора!",
		0 : "Выбар тэрміна выканання звароту недаступны! Калі ласка, запоўніце графік працы арганізацыі ў асабістым кабінеце Знешняга Адміністратара!"
	},
    dateRequired: {
		1 : 'Поле должно быть заполнено! ',
		0 : 'Поле павінна быць запоўнена!'
	}
}

export default i18n